import type { FileList } from "../../../parts/filelist/filelist"
type InvoiceOverviewState = {
  activeFilePopup: string
}

type InvoiceDetailState = {
  invoices: { [key: string]: InvoiceDetail }
}

type DPInvoiceDetailState = {
  dpInvoices: { [key: string]: DPInvoiceDetail }
}

type InvoiceDetail = {
  cardCode: string
  cardName: string
  docDate: string
  docDueDate: string
  refNum: string
  paidRate: number
  attachments: FileList
}

type DPInvoiceDetail = {
  cardCode: string
  cardName: string
  docDate: string
  docDueDate: string
  refNum: string
  paidRate: number
  attachments: FileList
}

let invoiceOverview: InvoiceOverviewState = {
  activeFilePopup: "",
}

let dpInvoiceDetail: DPInvoiceDetailState
let invoiceDetail: InvoiceDetailState

export let DATInvoice = { dpInvoiceDetail, invoiceDetail, invoiceOverview }
